import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedstate from 'vuex-persistedstate';
// import chat from '@/store/chat'
Vue.use(Vuex)
const store = new Vuex.Store({
    plugins: [
        createPersistedstate()
    ], //加上这个就可以了 //里面设置需要缓存的内容,
    state: {
        userinfo: '',
        isShowFilter: '',
        token: localStorage.getItem('token') || '',
        personalComponentId: 'PersonInfo', //个人中心左边侧边栏点击切换右边内容 默认显示 个人信息
    },
    mutations: {
        SET_TOKEN(state, newToken) {
            state.token = newToken;
            if (newToken) {
                localStorage.setItem('token', newToken);
            } else {
                localStorage.removeItem('token');
            }
        },
        edituserinfo(state, data) {
            state.userinfo = data
        },
        changeShowFilter(state) {
            console.log(state.isShowFilter, '1111')
            state.isShowFilter = !state.isShowFilter;
        },
        setPersonalComponentId(state, data) {
            state.personalComponentId = data
        }
    },
    actions:{
    },
    modules:{
        // chat
    }

})

export default store;